import KnownRegNumberFields from "./known-reg-number-fields";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import {
   VAN_BODY_TYPES,
   VAN_DOOR_OPTIONS,
   VAN_ROOF_TYPE_OPTIONS,
   VAN_SEAT_OPTIONS,
   VAN_WHEEL_BASE_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";

export default function VehicleDetails(
    {
        data,
        handlers
    }
) {

    return (
        <div className="vehicle-details-block">
            <SectionHeading
                text="Van details"
            />

            <div className="row">

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3"
                    labelText="Do you know the van registration number? "
                    required={true}
                    controlName="isVanRegistrationNumKnown"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.isVanRegistrationNumKnown}
                    onChange={handlers.onControlChange}
                />

            </div>

            {data.isVanRegistrationNumKnown === 'Yes' && <KnownRegNumberFields
                data={data}
                handlers={handlers}
            />}

            {/*{data.isVanRegistrationNumKnown === 'No' && <UnKnownRegNumberFields
                data={data}
                handlers={handlers}
            />}*/}

            {/*
                Modifications info ...
            */}

            {/*<VanModifications
                data={data}
                handlers={handlers}
            />*/}

            <div className="row">
                {/* Body type */}

                <ScrollableDropdownBlock
                    controlName="vanBodyType"
                    containerCssClass="col-12 py-3 "
                    labelText="Body type"
                    required={true}
                    options={VAN_BODY_TYPES}
                    selectedValues={data.vanBodyType}
                    onChange={handlers.onControlChange}
                    helpText=""
                />


                {/* Number of seats */}

                <ScrollableDropdownBlock
                    controlName="vanSeatNumber"
                    containerCssClass="col-12 py-3"
                    labelText="Number of seats"
                    required={true}
                    options={VAN_SEAT_OPTIONS}
                    selectedValues={data.vanSeatNumber}
                    onChange={handlers.onControlChange}
                    helpText=""
                />


                {/* Number of doors */}

                <ScrollableDropdownBlock
                    controlName="vanDoorNumber"
                    containerCssClass="col-12 py-3"
                    labelText="Number of doors"
                    required={true}
                    options={VAN_DOOR_OPTIONS}
                    selectedValues={data.vanDoorNumber}
                    onChange={handlers.onControlChange}
                    helpText=""
                />


                {/* Any Signs/Stickers on the van? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3"
                    labelText="Any signs/stickers on the van?"
                    required={true}
                    controlName="anySignOfStickers"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.anySignOfStickers}
                    onChange={handlers.onControlChange}
                />


                {/* Roof type */}

                <ScrollableDropdownBlock
                    controlName="vanRoofType"
                    containerCssClass="col-12 py-3"
                    labelText="Roof type"
                    required={true}
                    options={VAN_ROOF_TYPE_OPTIONS}
                    selectedValues={data.vanRoofType}
                    onChange={handlers.onControlChange}
                    helpText=""
                />


                {/* Wheel base */}

                <ScrollableDropdownBlock
                    controlName="vanWheelBase"
                    containerCssClass="col-12 py-3"
                    labelText="Wheel base"
                    required={true}
                    options={VAN_WHEEL_BASE_OPTIONS}
                    selectedValues={data.vanWheelBase}
                    onChange={handlers.onControlChange}
                    helpText=""
                />


                {/* Estimated van value */}


                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3"
                    labelText="Estimated van value"
                    required={true}
                    controlName="vanEstimatedValue"
                    value={data.vanEstimatedValue}
                    onChange={handlers.onControlChange}
                    inputAttrs={{"type": "number", "maxLength": 10}}
                    asTextArea={false}
                />


                {/* Is the van an import? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3"
                    labelText="Is the van an import?"
                    required={true}
                    controlName="isVanImported"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.isVanImported}
                    onChange={handlers.onControlChange}
                />


            </div>

            <div className="row">
                {/* Is the van impounded with police? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Is the van impounded with police?"
                    required={true}
                    controlName="vanImpoundedWithPolice"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.vanImpoundedWithPolice}
                    onChange={handlers.onControlChange}
                />
            </div>
        </div>
    );

}